import { useNavigate } from 'react-router';
import cln from 'classnames';
import {
  BaseButton,
  Text,
  useZustandModalKitStore,
  zustandModalKitSelector,
  EModalTypes,
} from 'react-gldn-kit';

import { ERouteNames } from 'Routes/types';

import styles from './Benefits.module.css';

const Benefits = ({ classes }: { classes?: string }) => {
  const navigate = useNavigate();

  const closeAndOpen = useZustandModalKitStore(
    zustandModalKitSelector.closeAndOpenModalAction
  );

  const jumpToVip = () => {
    navigate(ERouteNames.PromotionsVipClub);

    closeAndOpen(EModalTypes.Unknown);
  };

  return (
    <div className={cln(styles.wrapperBenefits, classes)}>
      <div className={styles.benefits}>
        <div className={styles.exploreBenefits}>
          <Text idT="bonusCabinet.exploreVIPBenefits" />
        </div>
        <div className={styles.discoverService}>
          <Text idT="bonusCabinet.discoverService" />
        </div>
      </div>

      <BaseButton
        handleClick={jumpToVip}
        text="bonusCabinet.howToGetBonuses"
        color="transparent"
        size="--button-full"
        centreText
        buttonHeight="--button-height-xl"
        classes={styles.getInfoButton}
      />
    </div>
  );
};

export default Benefits;
